import { render } from "./ModalChatUser.vue?vue&type=template&id=1280f2fe&scoped=true"
import script from "./ModalChatUser.vue?vue&type=script&lang=js"
export * from "./ModalChatUser.vue?vue&type=script&lang=js"

import "./ModalChatUser.vue?vue&type=style&index=0&id=1280f2fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1280f2fe"]])

export default __exports__